import {React} from '@api'
import {Suggest} from '@blueprintjs/select'
import {IFilterValue, FilterGroupState} from '@modules/catalog'
import {ICatalogFieldConfig, CatalogImageSourceConfig, CatalogPerspectiveConfig, IWorkspacePreset, LibraryItemConfig, SeasonSelectorFieldConfig, WorkspaceConfig} from '@stores'
import {IMerchCollectionC8, IMerchFolderC8, IMerchPlanC8, IMerchSeasonC8} from '@stores/c8/C8ServicesStore'
import { IconName } from '@blueprintjs/core'

export const CatalogSuggest = Suggest.ofType<ICatalogSearchResult>()

export type CatalogSuggestSearchResultType =
  'library'
  | 'libraryItem'
  | 'field'
  | 'plan'
  | 'merchSeason'
  | 'folder'
  | 'collection'
  | 'workspace'
  | 'workspaceView'
  | 'groupBy'
  | 'action'
  | 'perspective'
  | 'catalog'
  | 'image'
  | 'filter'
  | 'cardSetting'
  | 'filterValue'
| 'card' | string

export type CatalogSuggestActionType =
  'nav'
  | 'filter'
  | 'groupBy' | 'sort' | 'toggleCardField' | 'gotoField' | 'collapseAll' | 'expandAll' | 'toggleLOD' | 'togglePDF' | 'clear' | 'clearFilters' | 'gotoFilters' | 'clearHierarchy'
  | 'search' | 'filterField' | 'setImageSource' | 'clearSearch'
  | 'toggleCardFieldLabels' | 'loadCustomView' | 'createCatalogItem' | 'clearSelection' | 'toggleInlineDetails' | 'gotoSeasonSelectorField'
  | 'resetWorkspace' | 'selectOffline' | 'uploadOffline' | 'clearFilter' | 'toggle' | 'gotoLibraryItem' | 'gotoCatalogItem' | string

type SearchItemValue =
  LibraryItemConfig
  | ICatalogFieldConfig
  | IMerchPlanC8
  | IMerchCollectionC8
  | IMerchFolderC8
  | IMerchSeasonC8
  | IWorkspacePreset
  | CatalogPerspectiveConfig
  | CatalogImageSourceConfig
  | IFilterValue
  | FilterGroupState
  | WorkspaceConfig
  | SeasonSelectorFieldConfig

/**
 * {@param T .value type}
 * {@param T .parent type}
 * {@param C .Child type}
 */
export interface ICatalogSearchResult<T extends SearchItemValue = any, P extends SearchItemValue = any, C extends SearchItemValue = any> {
  key?: string
  title?: string
  subtitle?: string
  count?: number

  children?: ICatalogSearchResult<C>[]
  parent?: ICatalogSearchResult<P>

  icon?: IconName | React.ReactNode

  /**
   * Defaults to _.startCase(type)
   */
  groupLabel?: string

  pathLabel?: string
  selectedVlpChildren?: Array<string>

  keywords?: Array<string>

  /** Show a modal to confirm the action **/
  confirm?: boolean

  // Currently we divide the suggest GUI by type and use the action label -> action -> type as what we show in the chip
  group?: string

  type?: CatalogSuggestSearchResultType

  action?: CatalogSuggestActionType
  actionLabel?: string
  /**
   * sortableType is used in sort by serch result to provide the
   * alphabetical sort and custom sort.
   */
  sortableType?: 'alphabetical' | 'custom'
  esHit?: {
    index?: string
    _id?: string
    data?: any
  }

  value?: T

  esIndex?: string
  loading?: boolean
}

export type FilterValueSearchResult = ICatalogSearchResult<IFilterValue, ICatalogFieldConfig>
export type FilterGroupSearchResult = ICatalogSearchResult<ICatalogFieldConfig, {}, IFilterValue>
export type CatalogFieldSearchResult = ICatalogSearchResult<ICatalogFieldConfig>


// WEBPACK FOOTER //
// ./src/modules/catalogSearcher/CatalogSearchTypes.ts